export const breakpointThresholds = {
  xs: 600,
  sm: 960,
  md: 1280,
  lg: 1366,
  xl: 1440,
  xxl: 1660,
};
